module.exports = __webpack_public_path__ + "img/undraw_Appreciation_re_p6rl.e5202996.svg";